export const ERROR_MESSAGES = {
  auth: {
    invalidCredentials: "Invalid email or password. Please try again.",
    accountLocked: "Account temporarily locked due to too many failed attempts.",
    sessionExpired: "Your session has expired. Please sign in again.",
    unauthorized: "You don't have permission to perform this action.",
    emailInUse: "This email address is already registered.",
  },
  validation: {
    required: (field: string) => `${field} is required.`,
    invalid: (field: string) => `Invalid ${field} format.`,
    tooShort: (field: string, min: number) => `${field} must be at least ${min} characters.`,
    tooLong: (field: string, max: number) => `${field} must be less than ${max} characters.`,
    passwordRequirements: "Password must contain uppercase, lowercase, number, and special character.",
  },
  api: {
    networkError: "Unable to connect to the server. Please check your internet connection.",
    timeout: "Request timed out. Please try again.",
    rateLimited: "Too many requests. Please try again later.",
    serverError: "An unexpected error occurred. Our team has been notified.",
  },
  upload: {
    tooLarge: "File size exceeds the maximum limit.",
    invalidType: "File type not supported.",
    uploadFailed: "Failed to upload file. Please try again.",
    scanFailed: "File security scan failed. Please try a different file.",
  }
}